module.exports = __webpack_public_path__ + "img/xindai_step_yihuihua.4c8456e6.png";